/// <amd-module name="Artifacts/Npm/components/NpmPackageOverview" />

import { getCopyInstallCommand } from "Artifacts/Npm/helpers/InstructionsHelper";
import * as NpmRes from "Artifacts/Npm/Resources";
import { INpmDataService, INpmReadmeContent } from "Artifacts/Npm/services/NpmDataService";
import { PackageDeletedMessageCard } from "Artifacts/Package/components/package-details-common/PackageDeletedMessageCard";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import * as React from "react";
import { useEffect, useState } from "react";
import { generatePath, useHistory } from "react-router-dom";
import * as Utils_String from "VSS/Core/Util/String";
import { MarkdownRendererComponent } from "VSS/Features/Markdown/MarkdownRendererComponent";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { useComponentContext } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

const NpmPackageOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const history = useHistory();
  const { pageContext } = useComponentContext();
  const [rawReadmeContent, setRawReadmeContent] = useState<string>("");

  useEffect(() => {
    let mounted = true;

    const npmDataService = pageContext.getService<INpmDataService>("INpmDataService");
    npmDataService
      .getReadmeUnscopedPackage(feed, pkg.name, version.normalizedVersion)
      .then((readmeContent: INpmReadmeContent) => {
        mounted && setRawReadmeContent(readmeContent.rawReadmeContent);
      });

    return () => {
      mounted = false;
    };
  }, [feed, pageContext, pkg.id, pkg.name, version]);

  return (
    <div className="package-overview-content">
      {version.protocolMetadata?.data?.deprecated && (
        <MessageCard severity={MessageCardSeverity.Warning} className="message-card">
          <FormatComponent format={NpmRes.PackageDeprecatedMessage}>
            {version.version}
            {pkg.name}
            {version.protocolMetadata?.data?.deprecated}
          </FormatComponent>
        </MessageCard>
      )}
      {version.isDeleted && (
        <PackageDeletedMessageCard version={version.version} packageName={pkg.name} />
      )}
      {!version.isDeleted && (
        <PackageTile title={PackageRes.PackageDetails_GetThisPackage}>
          <div className="package-command">
            <Button
              iconProps={{
                iconName: "PlugConnected",
              }}
              onClick={() => {
                feed && history.push(generatePath(connectToFeed, { feedIdentifier: feed.name }));
              }}
            >
              {RootRes.ConnectToFeedButton}
            </Button>
            <span className="install-instructions-then">
              {PackageRes.PackageDetails_InstallInstructions_then}
            </span>
            <CopyableTextField text={getCopyInstallCommand(pkg.name, version)}></CopyableTextField>
          </div>
        </PackageTile>
      )}

      <PackageTile title={PackageRes.PackageDetails_Description}>
        <div className="package-description">{version.description}</div>
      </PackageTile>

      {!version.isDeleted && rawReadmeContent && (
        <PackageTile className="npm-readme">
          <article aria-label={Utils_String.format(NpmRes.NpmReadme, pkg.name)}>
            <MarkdownRendererComponent rawContent={rawReadmeContent} />
          </article>
        </PackageTile>
      )}
    </div>
  );
};

export { NpmPackageOverview };
